module.exports = __webpack_public_path__ + "static/media/purolator.285b1b74.png";